import { Chip, Stack } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import type { SelectOption } from "../filterTypes";

interface Props {
  selectedValues: string[];
  options: SelectOption[];
  onRemoveOption: (optionValue: string) => void;
  onClear: () => void;
}

const SelectedOptionsPanel = ({ selectedValues, options, onRemoveOption, onClear }: Props) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start",
        p: 1,
        border: 1,
        borderColor: "divider",
        borderRadius: "4px",
      }}
    >
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", flexGrow: 1, rowGap: 1 }}>
        {selectedValues.map((value) => {
          const label = options.find((option) => option.value === value)?.label ?? value;
          return <Chip variant="outlined" key={value} label={label} onDelete={() => onRemoveOption(value)} />;
        })}
      </Stack>
      {selectedValues.length > 0 && <CloseIconButton onClick={onClear} />}
    </Stack>
  );
};

export default SelectedOptionsPanel;
